import type { TrackedTranslation } from '@ps/web-core-intl';
import type { ClassNameProp, ValuesProp } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import trScreenVideo from '../../assets/video/tr-screen-video.mp4';
import trVideoMobile from '../../assets/video/tr-video-mobile.mp4';
import Prompt from '../Prompt/Prompt';

export type Handler = () => void;

interface TrackedText extends Partial<ValuesProp> {
  translation: TrackedTranslation;
}

interface TrackedButton extends Partial<ClassNameProp>, Partial<ValuesProp> {
  translation: TrackedTranslation;
  disabled?: boolean;
  href?: string;
}

interface Props {
  primaryButton?: TrackedButton;
  secondaryButton?: TrackedButton;
  onClose?: Handler;
  onPrimaryButtonClick?: Handler;
  onSecondaryButtonClick?: Handler;
  title: TrackedText;
  isExitPrompt?: boolean;
}

const TransitionProgressPrompt: React.FC<React.PropsWithChildren<Props>> = ({
  primaryButton,
  onPrimaryButtonClick,
  onSecondaryButtonClick,
  secondaryButton,
  title,
  children
}) => {
  const isMobile = useSelector(select.device.isMobile);
  const video = isMobile ? trVideoMobile : trScreenVideo;

  return (
    <Prompt
      title={title}
      noCloseButton
      primaryButton={primaryButton}
      secondaryButton={secondaryButton}
      onPrimaryButtonClick={onPrimaryButtonClick}
      onSecondaryButtonClick={onSecondaryButtonClick}
      variant="info"
      video={video}
    >
      {children}
    </Prompt>
  );
};

export default TransitionProgressPrompt;
